const EXTERNAL_KIND_DPO = 'external_dpo'
const INTERNAL_KIND_DPO = 'internal_dpo'
const SUBSTITUTE_KIND_DPO = 'substitute_dpo'

const PRINCIPAL_DPO_KIDS = [EXTERNAL_KIND_DPO, INTERNAL_KIND_DPO]

const NAME_DPO_STAGE = 'name_dpo'

const DRAFT_STAGE_STATUS = 'draft'
const AWAITING_REVIEW_STAGE_STATUS = 'awaiting_review'
const REVIEWING_STAGE_STATUS = 'reviewing'
const REFUSED_STAGE_STATUS = 'refused'
const APPROVED_STAGE_STATUS = 'approved'

const OPEN_STAGE_STATUSES = [DRAFT_STAGE_STATUS, REFUSED_STAGE_STATUS]

export default {
  EXTERNAL_KIND_DPO,
  INTERNAL_KIND_DPO,
  SUBSTITUTE_KIND_DPO,
  PRINCIPAL_DPO_KIDS,
  NAME_DPO_STAGE,
  OPEN_STAGE_STATUSES,
  DRAFT_STAGE_STATUS,
  AWAITING_REVIEW_STAGE_STATUS,
  REVIEWING_STAGE_STATUS,
  REFUSED_STAGE_STATUS,
  APPROVED_STAGE_STATUS,
}
